<template>
  <el-dialog :visible.sync="dialog" :show-close="true" width="90%" center>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-position="top"
    >
      <el-form-item :label="$t('cliente')" prop="customer" v-if="userType !== '2' && userType !== '5'">
        <CustomerList
          v-model="ruleForm.customer"
          v-bind:customerType="1"
          v-bind:current="ruleForm.customer"
        />
      </el-form-item>
      <el-form-item :label="$t('nome')" prop="name">
        <el-input
          type="text"
          placeholder="Titulo"
          v-model="ruleForm.name"
          maxlength="40"
          show-word-limit
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('imagem')" prop="image">
        <el-upload
          class="avatar-uploader"
          action="/api/services/upload"
          accept="image/png, image/jpeg"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="changeFile"
        >
          <img v-if="ruleForm.content" :src="ruleForm.content" class="image-service" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <el-button @click="save" type="warning">Salvar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ExternalService } from "@/services/customers/external.services";
import { ServicesService } from "@/services/customers/services.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

export default {
  name: "ExternaAdd",
  components: {
    CustomerList,
  },
  props: {
    dialog: Boolean,
    userType: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    changeFile(file) {
      var vm = this;
      ServicesService.upload(file)
        .then((response) => {
          vm.ruleForm.token = response.token;
          vm.ruleForm.content = response.content;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.add(vm.ruleForm)
        .then(() => {
          this.$message({
            type: "success",
            message: "Terceiro cadastrado com sucesso!",
          });
          vm.ruleForm.content = "";
          vm.ruleForm.name = "";
          vm.ruleForm.customer = "";
          vm.ruleForm.token = "";
          this.$emit("close");
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        customer: "",
        token: "",
        name: "",
        content: "",
      }
    };
  },
};
</script>
<style scoped>
.image-service {
  width: 208px;
  height: 120px;
  display: block;
}
</style>